import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { CartStatus } from 'src/items-list/business-logic/service/enumerations/cart-status';
import { ICustomerState } from '../../interfaces/states/ICustomerState';
import { ITransactionState } from '../../interfaces/states/ITransactionState';
import { ExemptibleTax } from 'src/tax-exemption/interfaces/exemptible-tax.interface';

const initialState: ITransactionState = {
  transactionId: '',
  isTransactionTotaled: false,
  sequenceNumber: 0,
  transactionIdExists: false,
  transactionCustomer: undefined,
  transactionTaxExemptApplied: false,
  taxAuthoritiesInCartList: [],
  shownPromotions: [],
};

class TransactionReducer extends ImmerReducer<ITransactionState> {
  public setTransactionState(transactionState: ITransactionState): void {
    transactionState.transactionIdExists = transactionState.transactionId !== '';
    this.draftState = transactionState;
  }

  public setTransactionId(transactionId: string): void {
    const transactionIdExists = transactionId !== '';
    this.draftState = {
      ...this.draftState,
      transactionId,
      transactionIdExists,
    };
  }

  public setTransactionSequenceNumber(sequenceNumber: number): void {
    this.draftState = {
      ...this.draftState,
      sequenceNumber,
    };
  }

  public removeTransactionId(): void {
    this.draftState = {
      ...this.draftState,
      transactionId: '',
      transactionIdExists: false,
    };
  }

  public setCustomer(customer: Partial<ICustomerState>): void {
    this.draftState = {
      ...this.draftState,
      transactionCustomer: { ...customer },
    };
  }

  public removeCustomer(): void {
    this.draftState = {
      ...this.draftState,
      transactionCustomer: undefined,
    };
  }

  public setIsTransactionalTotaled(isTotaled: boolean): void {
    this.draftState = {
      ...this.draftState,
      isTransactionTotaled: isTotaled,
    };
  }

  public setTransactionLevelTaxes(isTransactionExempted: boolean): void {
    this.draftState = {
      ...this.draftState,
      transactionTaxExemptApplied: isTransactionExempted,
    };
  }

  public setTaxAuthoritiesInCartList(list: ExemptibleTax[]): void {
    this.draftState = {
      ...this.draftState,
      taxAuthoritiesInCartList: list.map(obj => obj.name),
    };
  }

  public setCartStatus(cartStatus?: CartStatus): void {
    this.draftState = {
      ...this.draftState,
      cartStatus,
    };
  }

  public addShownPromotion(promotionId: string): void {
    const currentPromotions = this.draftState?.shownPromotions || [];
    this.draftState.shownPromotions = [...currentPromotions, promotionId];
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const TransactionActions = createActionCreators(TransactionReducer);
export const TransactionReducerFunction = createReducerFunction(TransactionReducer, initialState);
